// extracted by mini-css-extract-plugin
export var resizer = "_fk-0";